import { render, staticRenderFns } from "./OrderClaimDetailModal.vue?vue&type=template&id=8768add2&"
import script from "./OrderClaimDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderClaimDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports